export class JsEventEmitter {
  events: Record<string | symbol, Map<Function, Function | null>> = {};

  private _on(event: string | symbol, originCb: Function, wrapCb?: Function) {
    if (!this.events[event]) {
      this.events[event] = new Map<Function, Function | null>();
    }

    this.events[event].set(originCb, wrapCb ?? null);
  }

  emit(event: string | symbol, ...args: any[]) {
    const cbs = this.events[event];
    cbs?.forEach((wrapCb, originCb) => {
      (wrapCb ?? originCb).apply(null, args);
    });
  }

  on(event: string | symbol, cb: (...args: any[]) => any) {
    this._on(event, cb);
  }

  once(event: string | symbol, cb: Function) {
    // 包装方法：执行一次后取消订阅
    const func = (...args: any[]) => {
      this.removeListener(event, cb);
      cb.apply(null, args);
    };

    this._on(event, cb, func);
  }

  removeListener(event: string | symbol, cb?: Function) {
    if (!cb) {
      this.events[event] = new Map<Function, Function | null>();
    } else {
      if (this.events[event]) {
        this.events[event].delete(cb);
      }
    }
  }

  removeAllListeners() {
    this.events = {};
  }
}
